export { default } from "./AdminConsoleFacultyDirectoryPage";
